import transaction from '@/api/transaction';
import { v1 as uuid } from 'uuid';
import * as types from './mutationTypes';

function fetchTransactionByFilter(params) {
  const query = { ...params };

  if (Array.isArray(params.districts) && params.districts.length > 0) {
    query.districts = params.districts.join(',');
  }
  return transaction.getTransactions(query);
}

function fetchTransactionByics() {
  return transaction.getOverallTransactions();
}

export default {
  updateFilter({ dispatch, commit }, filters) {
    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey]) {
        commit(types.UNSET_FILTER, filterKey); // remove filter from state if value is null
      } else {
        commit(types.SET_FILTER, {
          [filterKey]: filters[filterKey],
        });
      }
    });

    return dispatch('searchTransactions');
  },

  updateFilterWithCursor({ dispatch, commit, state }, payload) {
    const filters = payload.filters;
    const cursor = payload.cursor;
    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey]) {
        commit(types.UNSET_FILTER, filterKey); // remove filter from state if value is null
      } else {
        commit(types.SET_FILTER, {
          [filterKey]: filters[filterKey],
        });
      }
    });

    return dispatch('searchTransactionsByCursor', { filters: state.filters, cursor });
  },

  mainpageupdateFilter({ dispatch, commit }, filters) {
    // if (filters.icsType === 'ics') {
    //   return dispatch('fetchMainPageDefaultTransactions');
    // }

    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey]) {
        commit(types.UNSET_FILTER, filterKey); // remove filter from state if value is null
      } else {
        commit(types.SET_FILTER, {
          [filterKey]: filters[filterKey],
        });
      }
    });
    // return dispatch('filterDefaultTransactions');
    return dispatch('fetchMainPageDefaultICSTransactions');
  },

  filterDefaultTransactions({ commit, state }, filters) {
    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });

    const pagination = {
      pageSize: state.mainpageSize,
    };
    if (state.sorting) {
      pagination.order = `${state.sorting.field}-${state.sorting.direction}`;
    }
    return fetchTransactionByFilter({
      ...state.filters,
      ...pagination,
    }).then((transactions) => {
      transactions.transactions.splice(6, 16);
      commit(types.SET_FETCHED_TRANSACTIONS, { transactions, fetchId });
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  searchTransactions({ commit, state }, filters) {
    commit(types.RESET_FETCH_COUNT);

    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });

    const pagination = {
      pageSize: state.pageSize,
      cursor: 0,
    };
    if (state.sorting) {
      pagination.order = `${state.sorting.field}-${state.sorting.direction}`;
    }
    return fetchTransactionByFilter({
      ...state.filters,
      ...pagination,
    }).then((transactions) => {
      commit(types.SET_FETCHED_TRANSACTIONS, { transactions, fetchId });
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  searchTransactionsByCursor({ commit, state }, payload) {
    commit(types.RESET_FETCH_COUNT);

    const filters = payload.filters;
    const cursor = payload.cursor;
    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });

    const pagination = {
      pageSize: state.pageSize,
      cursor,
    };
    if (state.sorting) {
      pagination.order = `${state.sorting.field}-${state.sorting.direction}`;
    }
    return fetchTransactionByFilter({
      ...state.filters,
      ...pagination,
    }).then((transactions) => {
      commit(types.SET_FETCHED_TRANSACTIONS, { transactions, fetchId });
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  fetchDefaultTransactions({ commit, state }, filters) {
    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });

    return transaction.getTransactions({
      ...state.filters,
    }).then((transactions) => {
      commit(types.SET_FETCHED_DEFAULT_TRANSACTIONS, transactions);
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  fetchMainPageDefaultICSTransactions({ commit, state }, filters) {
    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });
    return transaction.getTransactions({
      ...state.filters,
    }).then((transactions) => {
      // commit(types.SET_FETCHED_DEFAULT_TRANSACTIONS, transactions);
      commit(types.SET_FETCHED_TRANSACTIONS, { transactions, fetchId });
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  fetchMainPageDefaultTransactions({ commit }, filters) {
    const fetchId = uuid();
    commit(types.START_FETCH_TRANSACTIONS, { filters, fetchId });

    return fetchTransactionByics().then((tx) => {
      const transactions = {};
      transactions.transactions = [];
      transactions.transactions.push(tx.i[0]);
      transactions.transactions.push(tx.i[1]);
      transactions.transactions.push(tx.c[0]);
      transactions.transactions.push(tx.c[1]);
      transactions.transactions.push(tx.s[0]);
      transactions.transactions.push(tx.s[1]);

      commit(types.SET_FETCHED_TRANSACTIONS, { transactions, fetchId });
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  updateDistrictFilter({ dispatch, commit, state }, actions) {
    const districts = state.filters.districts || [];
    Object.keys(actions).forEach((distCode) => {
      const selected = actions[distCode];
      const idx = districts.findIndex(dc => dc === distCode);
      if (selected && idx === -1) {
        districts.push(distCode);
      }
      if (!selected && idx !== -1) {
        districts.splice(idx, 1);
      }
    });

    commit(types.SET_FILTER, { districts });

    return dispatch('searchTransactions');
  },

  changeSorting({ dispatch, commit }, payload) {
    commit(types.CHANGE_SORTING, payload);

    return dispatch('searchTransactions');
  },

  fetchMoreTransactions({ commit, state, getters }) {
    commit(types.START_FETCH_MORE_TRANSACTIONS);

    const pagination = {
      pageSize: state.pageSize,
      cursor: getters.endCursor,
    };
    if (state.sorting) {
      pagination.order = `${state.sorting.field}-${state.sorting.direction}`;
    }

    fetchTransactionByFilter({
      ...state.filters,
      ...pagination,
    }).then((transactions) => {
      commit(types.APPEND_FETCHED_TRANSACTIONS, transactions);
      return transactions;
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

  searchTransactionsByPaginate({ commit, state }, cursor) {
    commit(types.RESET_FETCH_COUNT);
    commit(types.CLEAR_TRANSACTION_LIST);

    commit(types.START_FETCH_MORE_TRANSACTIONS);

    const pagination = {
      pageSize: state.pageSize,
      cursor,
    };
    if (state.sorting) {
      pagination.order = `${state.sorting.field}-${state.sorting.direction}`;
    }

    fetchTransactionByFilter({
      ...state.filters,
      ...pagination,
    }).then((transactions) => {
      commit(types.APPEND_FETCHED_TRANSACTIONS, transactions);
      return transactions;
    }).catch((e) => {
      commit(types.FETCH_TRANSACTIONS_ERROR, `failed get transactions: ${e}`);
    });
  },

};
